import getColor from '~/lib/getColor'

export const PLACEMENT = 'team-details-page'
export const DATE_FORMAT = 'MM-DD-YYYY'
export const QUOTES_TAB_TITLE = 'Quotes'
export const ORDERS_TAB_TITLE = 'Orders'
export const ANALYTICS_TAB_TITLE = 'Analytics'
export const MEMBERS_TAB_TITLE = 'Team members'

export const WRAP_STYLE = {
    maxWidth: '400px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
}
export const BORDER = `1px solid ${getColor('blackAlpha15')}`

export const QUOTES = 'quotes'
export const ORDERS = 'orders'
export const ANALYTICS = 'analytics'
export const MEMBERS = 'members'

export const TABS = {
    QUOTES,
    ORDERS,
    ANALYTICS,
    MEMBERS,
} as const

export const DEFAULT_PAGE_LIMIT = 10
export const DEFAULT_PAGE_NUMBER = 1

export const SEARCH_FILTER_KEY = 'query'
export const STATUS_FILTER_KEY = 'status'
export const PAGE_NUMBER_KEY = 'page'
